"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./MarketingProductNavbar.css");

var _react = _interopRequireWildcard(require("react"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../util/constants");

var _mobx = require("mobx");

var _class, _descriptor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var DEFAULT_CLASS = "marketing-product-navbar";
var FIXED_UNDER_HEADER = DEFAULT_CLASS + " fixed-under-header";
var DEFAULT_DESKTOP_DISTANCE = 620;
var DEFAULT_TABLET_DISTANCE = 450;
var MarketingProductNavbar = (_class = /*#__PURE__*/function (_React$Component) {
  _inherits(MarketingProductNavbar, _React$Component);

  var _super = _createSuper(MarketingProductNavbar);

  function MarketingProductNavbar(props) {
    var _this;

    _classCallCheck(this, MarketingProductNavbar);

    _this = _super.call(this, props);

    _initializerDefineProperty(_assertThisInitialized(_this), "resetFixedHeaderPosition", _descriptor, _assertThisInitialized(_this));

    _this.productNavRef = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }

  _createClass(MarketingProductNavbar, [{
    key: "scrollHandler",
    value: function scrollHandler() {
      var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var fixedHeight = window.innerWidth < 800 ? this.props.tabletTop || DEFAULT_TABLET_DISTANCE : this.props.desktopTop || DEFAULT_DESKTOP_DISTANCE;
      var classes = this.productNavRef.current.className;

      if (scrollTop >= fixedHeight && !(0, _includes.default)(classes, "fixed-under-header")) {
        this.productNavRef.current.className = FIXED_UNDER_HEADER;
      } else if (scrollTop < fixedHeight && (0, _includes.default)(classes, "fixed-under-header")) {
        this.productNavRef.current.className = DEFAULT_CLASS;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.onscroll = this.scrollHandler;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.onscroll = null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        ref: this.productNavRef,
        className: DEFAULT_CLASS
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "product-navbar-dropdown-input",
        type: "checkbox",
        id: "product-navbar-dropdown-input",
        "aria-label": "Product Navbar Dropdown"
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "product-navbar-dropdown-label",
        htmlFor: "product-navbar-dropdown-input",
        "aria-hidden": "true"
      }, "VIEW ALL PRODUCTS"), /*#__PURE__*/_react.default.createElement("div", {
        className: "product-navbar-dropdown"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "product-overview",
        href: _constants.URLS.MARKETING.PRODUCTS
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "Gradifi Products Overview",
        className: "product-overview-image",
        src: require("../assets/redesign2020/product-overview-border.png")
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "product-overview-body"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "product-overview-title"
      }, "Overview"), /*#__PURE__*/_react.default.createElement("span", {
        className: "product-description"
      }, "See the whole Gradifi suite of solutions."))), /*#__PURE__*/_react.default.createElement("a", {
        className: "product-fincore",
        href: _constants.URLS.MARKETING.REFI
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "Financial Core",
        className: "fincore-image",
        src: require("../assets/redesign2020/fincore-border-logo.png")
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "fincore-body"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "fincore-title"
      }, "FinancialCore"), /*#__PURE__*/_react.default.createElement("span", {
        className: "fincore-description"
      }, "Empower your employees with tools and resources."))), /*#__PURE__*/_react.default.createElement("a", {
        className: "product-slp",
        href: _constants.URLS.MARKETING.PAYDOWN
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "Student Loan Paydown",
        className: "slp-image",
        src: require("../assets/redesign2020/slp-border-logo.png")
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "slp-body"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "slp-title"
      }, "Student Loan PayDown"), /*#__PURE__*/_react.default.createElement("span", {
        className: "slp-description"
      }, "Help employees pay down student loans."))), /*#__PURE__*/_react.default.createElement("a", {
        className: "product-csu",
        href: _constants.URLS.MARKETING.SAVEUP
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "College SaveUp",
        className: "csu-image",
        src: require("../assets/redesign2020/csu-border-logo.png")
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "csu-body"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "csu-title"
      }, "College SaveUp"), /*#__PURE__*/_react.default.createElement("span", {
        className: "csu-description"
      }, "Offer employees solutions to save for their children's education."))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-navbar-spaceholder",
        "aria-hidden": "true"
      }));
    }
  }]);

  return MarketingProductNavbar;
}(_react.default.Component), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "resetFixedHeaderPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return -1;
  }
}), _applyDecoratedDescriptor(_class.prototype, "scrollHandler", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "scrollHandler"), _class.prototype)), _class);
MarketingProductNavbar.propTypes = {
  tabletTop: _propTypes.default.number,
  desktopTyop: _propTypes.default.number
};
var _default = MarketingProductNavbar;
exports.default = _default;